import { render, staticRenderFns } from "./OrderTransactionsTable.vue?vue&type=template&id=7f522398"
import script from "./OrderTransactionsTable.vue?vue&type=script&lang=js"
export * from "./OrderTransactionsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports